import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgGenderMale = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 11 20" {...props}>
    <g
      transform="translate(1 1)"
      stroke="#179FE3"
      fill="none"
      fillRule="evenodd"
    >
      <path d="m1.233 5.79 1.928.265a1 1 0 0 0 .136.009H5.67a1 1 0 0 0 .134-.01l2.012-.271a1 1 0 0 1 1.053 1.384L6.221 13.36a1 1 0 0 0-.08.393v3.565a1 1 0 0 1-1 1H3.972a1 1 0 0 1-1-1v-3.59a1 1 0 0 0-.085-.404L.182 7.184a1 1 0 0 1 1.05-1.394Z" />
      <circle cx={4.614} cy={2.159} r={2.159} />
    </g>
  </svg>
);
const Memo = memo(SvgGenderMale);
export default Memo;
